import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { GameLogo } from '../game/GameLogo';

interface AppHeaderProps {
  className?: string;
}

const AppHeader: React.FC<AppHeaderProps> = ({ className = '' }) => {
  const { iframeParams } = useAuth();

  return (
    <header
      data-test-id="app-header"
      className={`bg-[#333333] h-[100px] my-[22px] relative overflow-hidden ${className}`}
    >
      {/* Background Image Layer */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: 'url(/header-bg.png)',
          backgroundSize: '80.27%', // Image scaled up so only 11/14th is visible (14/11 = 1.2727)
          backgroundPosition: 'center calc(32%)',
          backgroundRepeat: 'no-repeat',
        }}
      />

      {/* Logo */}
      <div className="relative z-10 h-full flex items-center justify-center px-4">
        <div className="w-[94px] h-[70px] flex items-center justify-center">
          <GameLogo location={iframeParams.location} />
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
